import React from "react";
import Comment from "./comment";

export default function CommentTree(
  topElements,
  childrenElements,
  maxDepth = 0,
  depth,
  parentId,
  pageId,
  restUrl,
  setParentId,
  allowComments,
  user
) {
  return buildTree(topElements, childrenElements, depth);

  function buildTree(topElements, childrenElements, depth) {
    return (
      <>
        {topElements.map(element => {
          const id = element.id;
          const hasChildren = typeof childrenElements[id] !== "undefined";
          const answeredTo = parentId === id;

          function CurrentComment() {
            return (
              <Comment
                key={id}
                comment={element}
                answeredTo={answeredTo}
                pageId={pageId}
                restUrl={restUrl}
                setParentId={setParentId}
                allowComments={allowComments}
                user={user}
              />
            );
          }

          if (hasChildren && (maxDepth === 0 || maxDepth > depth + 1)) {
            return (
              <React.Fragment key={id}>
                {CurrentComment()}
                <ol className="comment-children">
                  {buildTree(childrenElements[id], childrenElements, depth + 1)}
                </ol>
              </React.Fragment>
            );
          } else if (hasChildren && maxDepth <= depth + 1) {
            return (
              <React.Fragment key={id}>
                {CurrentComment()}
                {buildTree(childrenElements[id], childrenElements, depth)}
              </React.Fragment>
            );
          } else {
            return CurrentComment();
          }
        })}
      </>
    );
  }
}